import type { ReactNode } from 'react';

import { Button } from '@/components';
import { cn } from '@/lib/utils';

/**
 * StyleToggleButton — kompaktowy przełącznik segmentowy panelu stylów.
 *
 * Panel stylów formatki używa dziesiątek małych przełączników (wyrównanie,
 * dekoracja, tryb wypełnienia, styl obramowania, overflow, pozycja ikony…).
 * Zamiast surowego `<button>` (blokada ESLint §4.12) opakowujemy prymityw
 * `Button` w wariancie `ghost` i nadpisujemy klasy stanu aktywnego/nieaktywnego
 * przez `cn()` (twMerge — ostatnia klasa wygrywa). Zachowuje zwarty wygląd
 * segmentów portowany z biblioteki formatek.
 */
const ACTIVE = 'border-accent-500 bg-accent-50 dark:bg-accent-900/30 text-accent-600';
const INACTIVE =
  'border-gray-200 dark:border-gray-700 text-gray-500 dark:text-gray-400 hover:border-gray-300';

interface StyleToggleButtonProps {
  active: boolean;
  onClick: () => void;
  children: ReactNode;
  title?: string;
  className?: string;
}

export function StyleToggleButton({
  active,
  onClick,
  children,
  title,
  className,
}: StyleToggleButtonProps) {
  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      onClick={onClick}
      title={title}
      className={cn(
        'flex-1 rounded border px-1 py-1.5 text-xs font-medium',
        active ? ACTIVE : INACTIVE,
        className,
      )}
    >
      {children}
    </Button>
  );
}
